import { useContext } from 'react';
import { types as repr } from '@sitebuilder/core';
import { AppContext } from '../components/AppContext';

export const useWidgetInstance = (widgetInstanceId?: string): repr.WidgetInstance => {
    const { document } = useContext(AppContext);
    const widgetInstances = document?.widgetInstances;
    const widgetInstance = (widgetInstances || {})[widgetInstanceId || ''];
    return widgetInstance;
};
